import type { AntwerpLandmark } from './antwerp-landmark';

/**
 * User-created points of interest, stored per-browser. Shape-compatible with
 * AntwerpLandmark so they pass through the same selection / side-panel /
 * map-layer infrastructure. Distinguished by the `isCustom` flag and the
 * `custom-` id prefix.
 *
 * Image is stored separately in IndexedDB and resolved through the
 * `customPOIImages` cache on the store.
 */
export interface CustomPOI extends AntwerpLandmark {
  isCustom: true;
  createdAt: number;
}

export function isCustomPOI(landmark: AntwerpLandmark): landmark is CustomPOI {
  return (landmark as CustomPOI).isCustom === true;
}

export const CUSTOM_POI_ID_PREFIX = 'custom-';

/** Generate a short, URL-safe id for a new custom POI. */
export function makeCustomPOIId(): string {
  // Use crypto.randomUUID when available; otherwise fall back to a short
  // base36 string. Both are unique enough for a per-browser store.
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return CUSTOM_POI_ID_PREFIX + crypto.randomUUID().slice(0, 8);
  }
  return CUSTOM_POI_ID_PREFIX + Math.random().toString(36).slice(2, 10);
}
